import React, { useEffect, useState } from 'react';
import Header from '../Components/Header';
import { dash1, dash2, dash3, dash4 } from '../common/Assets/imgs';
import { get } from '../Services/ApiHandler';
import { URLS } from '../Services/Constant';

const Dashboard = () => {

    const [getData, setGetData] = useState(null);

    const getList = async () => {
        const res = await get(URLS?.DASHBOARD);
        console.log("res DASHBOARD", res);
        setGetData(res?.data);
    }

    useEffect(() => {
        getList();
    }, []);

    const sections = [
        {
            title: 'Dashboard',
            list: [
                { value: getData?.total_users, name: 'Total User', img: dash4 },
                { value: getData?.total_transport, name: 'Total Transports', img: dash3 },
                { value: getData?.total_vechicles, name: 'Total Vehicles', img: dash3 },
                { value: getData?.total_driver, name: 'Total Drivers', img: dash2 },
            ]
        },
        {
            title: 'Total Trips',
            list: [
                { value: getData?.upcoming_trip, name: 'Upcoming Trip', img: dash3 },
                { value: getData?.total_ongoing, name: 'Ongoing Trip', img: dash3 },
                { value: getData?.total_complete, name: 'Completed Trip', img: dash3 },
                { value: getData?.total_cancelled, name: 'Cancelled Trip', img: dash3 },
            ]
        },
        {
            title: 'Total Payment Details',
            list: [
                {
                    value: `₹${Number(getData?.normal_user_total_amount || 0).toFixed(2)}`,
                    name: 'User Received',
                    img: dash1
                },
                { value: `₹${Number(getData?.transport_pending_amount || 0).toFixed(2)}`, name: 'Pending for Owners', img: dash1 },
                { value: `₹${Number(getData?.transport_completed_amount || 0).toFixed(2)}`, name: 'Transferred Owners', img: dash1 },
                { value: `₹${Number(getData?.special_completed_amount || 0).toFixed(2)}`, name: 'Special User', img: dash1 },
            ]
        },

    ];



    return (
        <div>
            <Header title={"dashboard"} />

            <div className='main-container'>

                {sections.map((section, secIndex) => (
                    <div key={secIndex} className="mb-4">

                        {/* Section Title */}
                        <h1 className='titlehead1'>{section.title}</h1>

                        {/* Cards */}
                        <div className='cardoverlay'>
                            {section.list.map((item, index) => (
                                <div key={index} className='cardbg'>
                                    <div>
                                        <h2 className='valuetxt'>{item.value}</h2>
                                        <span className='nametxt'>{item.name}</span>
                                    </div>
                                    <img src={item.img} alt="dashimg" className='dashimg' />
                                </div>
                            ))}
                        </div>

                    </div>
                ))}

            </div>
        </div>
    );
};

export default Dashboard;
